import styled from 'styled-components';
import Box from '@tds/core-box';

export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 16px 6rem 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export const customStyles = `
  overflow: scroll;
  max-height: 80% !important;
  height:83%;
  width: 67%;
  position: fixed;
  margin-left: 17%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;
  text-align:left;`;

export const DatePickerContainer = styled(Box)`
  .react-datepicker-wrapper {
    width: 200px;
  }
`;

export const OrderSummaryMain = styled.div`
  padding: 1rem;
  margin-top: 2rem;
  border: 1px solid #d8d8d8;
`;

export const TableBottomBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2rem;
  padding: 0 1.8rem;
  margin-right: 7%;
`;

export const Text = styled.p`
  font-weight: ${props => (props.bold ? '600' : props.fontWeight || '400')};
  font-size: 16px;
  display: inline;
  letter-spacing: -0.2px;
  color: ${props => props.color};
`;
